import { styled } from '~/styled'

export const DialogScrollableContent = styled('div', {
  base: ['overflow-scroll', 'flex-1', 'p-4']
})
